import { isTestEnv } from './constant.js'

const taroH5PreFix = isTestEnv ? 'https://baoh5test.turingsenseai.com/h5/#/' : 'https://baoh5.turingsenseai.com/h5/#/'

const h5PreFix = isTestEnv ? 'https://baoh5test.turingsenseai.com/#/' : 'https://baoh5.turingsenseai.com/#/'

export const H5PAGES_TARO_CONFIG = {
  // 跳转商详
  toProductDetail (pid) {
    window.location.href = `${taroH5PreFix}pages/choice/detail?pid=${pid}`
  },
  // 跳转售卖
  toSaleIndex () {
    window.location.href = `${taroH5PreFix}pages/sell/index`
  },
  // 跳转鉴别
  toIndentify () {
    window.location.href = `${taroH5PreFix}common/select/category?op=identify`
  },
  // 跳转品牌选择
  toSelectBrand (op, key, mode) {
    window.location.href = `${taroH5PreFix}pages/common/select/brand?op=${op}&key=${key}&mode=${mode}`
  },
  // 跳转品牌馆
  toBrandPavilion (kindId, brandId) {
    window.location.href = `${taroH5PreFix}subPackages/choice/brand-pavilion/index?brandID=${brandId}&kindID=${kindId}`
  }
}
